import '../game.css';
const React = require('react');

const PanelComponent = require('./panelComponent').default;
const ObjectComponent = require('./objectComponent').default;

const gameParamator = require('../../../define/gameParamater').default;
const objectType = require('../../../define/object').default;
const dragType = require('../../../define/dragType').default;
const { getShapeAreaRelativePosition } = require('../../../core/shape').default;
const { isInsideArea } = require('../../../utils').default;
// ============================

const getArroundPanelArray = (targetX, targetY, attackObject, damage) => {
    const arroundPanelArray = [];
    const arround = [{ x: 1, y: 0 }, { x: 0, y: 1 }, { x: -1, y: 0 }, { x: 0, y: -1 }];
    arround.forEach(element => {
        const posX = targetX + element.x;
        const posY = targetY + element.y;
        if (posX < 0 || posX < gameParamator.HORIZONTAL_PANEL ||
            posY < 0 || posY < gameParamator.VERTICAL_PANEL) {
            arroundPanelArray.push({
                posX,
                posY,
                damage,
                attackObject
            })
        }
    })
    return arroundPanelArray;
}


const getScorePoint = (panel) => {
    if (objectType.isMonsterObject(panel.object)) {
        return panel.damage + panel.bonus;
    } else if (objectType.isTreasure(panel.object)) {
        return panel.bonus;
    } else {
        return 1;
    }
}

export default class boardComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dragEvent: {
                posX: 0,
                posY: 0,
                isHover: false,
                itemProps: null,
                canPlacement: false,
                itemType: undefined
            }
        };
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            const { isGamePlaying } = this.props;
            if (isGamePlaying) {
                this.boardStateUpdate(this.props)
            }
        }, this.props.updateInterval);
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }


    boardStateUpdate(props) {
        const { state: { boardArray }, isSubjugation } = props;
        let chainDamageArray = [];
        const remainMobArray = [];
        boardArray.map(horizontal => {
            horizontal.map(panel => {
                if (!objectType.isBlank(panel.object) && panel.hp <= 0) {
                    if (objectType.isPorinObject(panel.object)) {
                        chainDamageArray = chainDamageArray.concat(
                            getArroundPanelArray(panel.posX, panel.posY, panel.object, panel.damage * 2))
                    }
                    props.addScore(getScorePoint(panel));
                    props.onDeleteItem(panel.posX, panel.posY, panel.gimmickNo);
                    if (objectType.isTreasure(panel.object)) {
                        props.onBreakTreasure();
                    }
                }
                if (objectType.isMonsterObject(panel.object) && panel.hp > 0) {
                    remainMobArray.push(panel);
                }
            })
        });
        if (chainDamageArray.length !== 0) {
            props.onChainDamage(chainDamageArray);
        }
        if (isSubjugation) {
            // Is the target alive? 
            if (!remainMobArray.some(panel => panel.target)) {
                props.onClearStage();
            }
        }
        if (remainMobArray.length === 0) {
            props.onClearStage();
        }
    }


    canPlacement(x, y, itemProps) {
        const { state: { boardArray } } = this.props;
        const { type, rotate } = itemProps;
        const shapeArray = getShapeAreaRelativePosition(type, rotate);
        const found = shapeArray.find(element => {
            const checkPosX = element.posX + x;
            const checkPosY = element.posY + y;
            if (isInsideArea(checkPosX, checkPosY)) {
                return boardArray[checkPosX][checkPosY].object !== objectType.OBJ_BLANK;
            }
            return true;
        })
        return !found;
    }

    setHoverEvent(x, y, isHover, itemType, itemProps) {
        const { dragEvent } = this.state;
        let canPlacement = false;
        if (!isHover && (x !== dragEvent.posX || y !== dragEvent.posY)) {
            return;
        }

        if (itemType === dragType.PORIN_BOX) {
            if (isHover) {
                canPlacement = this.canPlacement(x, y, itemProps);
            }
        } else {
            canPlacement = true;
        }
        this.setState({
            dragEvent: {
                posX: x,
                posY: y,
                isHover,
                itemProps,
                canPlacement,
                itemType
            }
        })
    }

    isPlacementArea(x, y) {
        const { dragEvent } = this.state;
        if (!dragEvent.canPlacement) {
            return false;
        }
        const { itemProps, posX, posY, itemType } = dragEvent;
        let shapeArray = [];
        if (itemType === dragType.PORIN_BOX) {
            const { type, rotate } = itemProps;
            shapeArray = getShapeAreaRelativePosition(type, rotate);
        } else if (itemType === dragType.SKILL) {
            const { playerSkillArea } = itemProps;
            shapeArray = playerSkillArea;
        }
        const found = shapeArray.find(element =>
            (x === (element.posX + posX) && y === (element.posY + posY))
        )
        return !!found;
    }

    dropPorinBox(x, y, itemProps) {
        if (this.canPlacement(x, y, itemProps)) {
            const { type, porins, rotate, frameId } = itemProps;
            // console.log(itemProps);
            const shapeArray = getShapeAreaRelativePosition(type, rotate);
            const dropItemArray = shapeArray.map((element, index) => {
                return {
                    posX: element.posX + x,
                    posY: element.posY + y,
                    object: porins[index],
                    hp: 1,
                    mhp: 1
                }
            }
            )
            this.props.onDropItem(dropItemArray, frameId);
        }
        this.setState({
            dragEvent: {
                posX: 0,
                posY: 0,
                isHover: false,
                itemProps: null,
                canPlacement: false,
                itemType: undefined
            }
        })
    }
    /*
        props:
        playerCharactor: player.PLAYER_SAMMONER,
        playerName: "",
        playerSkill: null,
        playerSkillName: "",
        playerSkillCoolTime: 0,
        playerSkillArea: [],
        playerSkillDamage: 0,
        baseTime: undefined,
        startedAt: undefined,
        stoppedAt: undefined,
    */
    dropPlayerSkill(x, y, itemProps) {
        const { playerSkillArea, playerSkillDamage } = itemProps;
        const dropItemArray = playerSkillArea.map(element => {
            return {
                posX: element.posX + x,
                posY: element.posY + y,
                damage: playerSkillDamage,
                attackObject: objectType.OBJ_BLANK
            }
        }
        )
        // console.log(dropItemArray);
        this.props.onDropSkill(dropItemArray);

        this.setState({
            dragEvent: {
                posX: 0,
                posY: 0,
                isHover: false,
                itemProps: null,
                canPlacement: false
            }
        })
    }

    onDropEvent(x, y, itemType, itemProps) {
        switch (itemType) {
            case dragType.PORIN_BOX:
                return this.dropPorinBox(x, y, itemProps);
            case dragType.SKILL:
                return this.dropPlayerSkill(x, y, itemProps);
            default:
                return;
        }

    }

    renderPanel(index) {
        const { state: { boardArray }, soundEnable, isGamePlaying } = this.props;
        const x = index % gameParamator.HORIZONTAL_PANEL;
        const y = Math.floor(index / gameParamator.VERTICAL_PANEL);
        const isPlacementArea = this.isPlacementArea(x, y);
        return (
            <div key={index} className="board-panel">
                <PanelComponent
                    posX={x}
                    posY={y}
                    placement={isPlacementArea}
                    onDrop={(itemType, itemProps) => this.onDropEvent(x, y, itemType, itemProps)}
                    onHoverEvent={(isHover, itemType, itemProps) => this.setHoverEvent(x, y, isHover, itemType, itemProps)} >
                    <ObjectComponent isGamePlaying={isGamePlaying} soundEnable={soundEnable} type={boardArray[x][y].object} hp={boardArray[x][y].hp} mhp={boardArray[x][y].mhp} weakness={boardArray[x][y].weakness} />
                </PanelComponent>
            </div>
        )
    }

    renderBoard() {
        const panels = []
        for (let i = 0; i < (gameParamator.HORIZONTAL_PANEL * gameParamator.VERTICAL_PANEL); i++) {
            panels.push(this.renderPanel(i));
        }
        return panels;
    }

    render() {
        return (
            <>
                {this.renderBoard()}
            </>
        )
    }
}
